import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import COMPANY from '../legal/company';

// Product / Company / Legal, as on the footers of similar billing and ERP products (Vyapar, myBillBook, Zoho Books)
const COLUMNS = [
  {
    title: 'Product',
    links: [
      { href: '/guide/getting-started.html', label: 'Getting Started guide', external: true },
      { to: '/login', label: 'Sign in' },
      { to: '/register', label: 'Create an account' }
    ]
  },
  {
    title: 'Company',
    links: [
      { to: '/partners', label: 'Become a partner' },
      { to: '/contact', label: 'Contact us' },
      { to: '/security', label: 'Security & Data' }
    ]
  },
  {
    title: 'Legal',
    links: [
      { to: '/terms', label: 'Terms of Service' },
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/refund-policy', label: 'Refund & Cancellation' }
    ]
  }
];

/** Footer for every public page: what iBigDo is, where to go next, and the legal pages. */
function PublicFooter() {
  const { theme } = useTheme();
  const year = new Date().getFullYear();

  return (
    <footer className="public-footer border-top bg-body-tertiary mt-auto" data-bs-theme={theme}>
      <Container className="py-4">
        <Row className="g-4">
          <Col md={4}>
            <img
              src="https://s3.amazonaws.com/public.ibigdo.com/c/img/logo_ibigdo.png"
              alt="iBigDo"
              style={{ height: '1.75rem', objectFit: 'contain' }}
            />
            <p className="text-muted small mt-2 mb-0">
              One system for manufacturing, processing and trading businesses: purchase, stock, production, sales and
              accounts, with GST built in.
            </p>
            <p className="text-muted small mt-3 mb-0 public-footer-copyright">&copy; {year} {COMPANY.legalName}. All rights reserved.</p>
          </Col>
          {COLUMNS.map((col) => (
            <Col key={col.title} xs={6} md>
              <h2 className="public-footer-heading">{col.title}</h2>
              <ul className="list-unstyled mb-0">
                {col.links.map((l) => (
                  <li key={l.label} className="mb-1">
                    {l.external
                      ? <a href={l.href} target="_blank" rel="noopener noreferrer">{l.label}</a>
                      : <Link to={l.to}>{l.label}</Link>}
                  </li>
                ))}
              </ul>
            </Col>
          ))}
        </Row>
      </Container>
    </footer>
  );
}

export default PublicFooter;
